type OperationConfig = {
  key: Operator;
  types: string[]; // allowed types
};

/**
 * The allowed types for the ParseQueryForm.
 */
export const ALLOWED_TYPES = [
  "number",
  "string",
  "boolean",
  "date",
  "relation",
  "pointer",
  "array",
  "file",
  "object",
];

/**
 * The available operations for the ParseQueryForm identicating wich operation can be used with any type.
 */
export const OPERATIONS: OperationConfig[] = [
  {
    key: "exists",
    types: [
      "number",
      "string",
      "boolean",
      "date",
      "pointer",
      "array",
      "file",
      "object",
    ],
  },
  {
    key: "doesNotExist",
    types: [
      "number",
      "string",
      "boolean",
      "date",
      "pointer",
      "array",
      "file",
      "object",
    ],
  },
  { key: "equalTo", types: ["number", "string", "boolean", "date", "pointer"] },
  {
    key: "notEqualTo",
    types: ["number", "string", "boolean", "date", "pointer"],
  },
  {
    key: "containedIn",
    types: ["number", "string", "boolean", "pointer", "date"],
  },
  {
    key: "notContainedIn",
    types: ["number", "string", "boolean", "pointer", "date"],
  },
  { key: "greaterThan", types: ["number", "date"] },
  { key: "lessThan", types: ["number", "date"] },
  { key: "greaterThanOrEqualTo", types: ["number", "date"] },
  { key: "lessThanOrEqualTo", types: ["number", "date"] },
  { key: "contains", types: ["string"] },
  { key: "startsWith", types: ["string"] },
  { key: "endsWith", types: ["string"] },
  { key: "matchesQuery", types: ["relation", "pointer"] },
  { key: "doesNotMatchQuery", types: ["relation", "pointer"] },
  {
    key: "matchesKeyInQuery",
    types: ["number", "string", "boolean", "date", "pointer"],
  },
  {
    key: "doesNotMatchKeyInQuery",
    types: ["number", "string", "boolean", "date", "pointer"],
  },
];

/**
 * The available operators for the ParseQueryForm.
 */
export type Operator =
  | "exists"
  | "doesNotExist"
  | "equalTo"
  | "notEqualTo"
  | "greaterThan"
  | "lessThan"
  | "greaterThanOrEqualTo"
  | "lessThanOrEqualTo"
  | "contains"
  | "startsWith"
  | "endsWith"
  | "matchesKeyInQuery"
  | "doesNotMatchKeyInQuery"
  | "matchesQuery"
  | "doesNotMatchQuery"
  | "containedIn"
  | "notContainedIn";

/**
 * Checks if the operator is a relation operator, wich sets the value field of the operation to another ParseQueryForm-Instance.
 * @param operator the operation to check.
 * @returns true if the operator is a relation operator, false otherwise.
 */
export function isRelationOperator(operator: Operator) {
  return (
    // add more relation operators here, if new one are added
    operator === "matchesQuery" ||
    operator === "doesNotMatchQuery" ||
    operator === "matchesKeyInQuery" ||
    operator === "doesNotMatchKeyInQuery"
  );
}
